const LeftNavLogoFull = ({ ...props }) => <img src="/storage/branding/logo-light.png" alt="logo" {...props} />;

export default LeftNavLogoFull;
